<template>
  <path pid="0" d="M7 24.39A4.35 4.35 0 013.9 17L15.08 5.79a2.92 2.92 0 114.13 4.13L8.82 20.31a1 1 0 01-1.41-1.41L17.8 8.51a.93.93 0 000-1.31.93.93 0 00-1.31 0L5.32 18.37a2.36 2.36 0 003.33 3.34l11.64-11.64a3.79 3.79 0 000-5.36 3.88 3.88 0 00-5.36 0L4.31 15.33a1 1 0 01-1.41-1.41L13.52 3.3a5.78 5.78 0 118.18 8.18L10.06 23.12A4.33 4.33 0 017 24.39z"/>
</template>
